import Redirect from "./auth/Redirect";
import AuthGuard from "./auth/AuthGuard";
import NotFound from "./views/sessions/NotFound";
import pagesRoutes from "./views/pages/pages-routes";
import sessionRoutes from "./views/sessions/session-routes";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import dashboardRoutes from "./views/dashboard/dashboard-routes";
import materialRoutes from "./views/material-kit/MaterialRoutes";

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...dashboardRoutes,
      ...materialRoutes,
      ...pagesRoutes,
    ]
  },
  ...sessionRoutes,
  { path: "/", element: <Redirect /> },
  { path: "*", element: <NotFound /> }
];

export default routes;
  